import React from "react";
import "./about_manet.css";
import "../../page_content.css";
import { cardData } from "../../cardData";

const extraCards = [
  {
    logo: "/assets/images/icons/businessman.webp",
    description:
      "Experienced Professionals for cadets' academic as OLQ training",
  },
  {
    logo: "/assets/images/icons/speech-bubble.webp",
    description:
      "Communication skills laboratory training to ensure personal effectiveness ",
  },
  {
    logo: "/assets/images/icons/restaurant.webp",
    description:
      "Best mess, and residential facilities",
  },
  {
    logo: "/assets/images/icons/football-field.webp",
    description:
      "Sports complex with all the indoor and outdoor Sports facilities and Olympic level swimming pool",
  },
];

const allCards = [...cardData, ...extraCards];

console.log(" allCards", allCards);

const AboutManet = () => {
  return (
    <>
      <div>
        <h1 className="title">About MANET</h1>
        <hr />
        <div className="aboutmanet-container">
          <img
            src="/assets/images/about/About_MANET-2.webp"
            alt="About MANET"
            className="aboutmanet-image"
          />
          <div className="aboutmanet-content">
            <p>
              MAEER's Maharashtra Academy of Naval Education and Training, more
              popularly known as MANET Pune, was founded in 2001 at the MIT,
              Kothrud Campus with a vision to train cadets to join Merchant
              Navy. MANET shifted to Rajbaug Campus, Loni-Kalbhor in 2004 and
              continues to develop top-notch cadets for the marine industry.
              MANET is approved by Directorate General of Shipping (DG
              Shipping), Ministry of Shipping, Government of India.
            </p>
            <p>
              Aspiring cadets can pursue 4 streams at MANET Pune - 4 year B.
              Tech Marine Engineering Course, 3 year B. Sc. in Nautical Science,
              1 Year Diploma in Nautical Science (DNS) leading to B. Sc Nautical
              Science or a 4 month Electro- Technical Officer (ETO) Course.
              MANET Pune has a Ship-in-Campus which is a fully operational
              replica of a ship's engine- room. Our cadets are trained in it to
              get a feel of the actual ship board engine-room operations. Want
              to explore a phenomenal career in Merchant Navy or Marine
              Engineering? Apply to MANET Pune today!
            </p>
          </div>
        </div>

        <section className="aboutmanet-section">
          <h1 className="title">What Makes Us Unique !</h1>
          <h2 className="subtitle">
            MANET equips future leaders with world-class training and global
            opportunities
          </h2>

          <div className="aboutmanet-cards-grid">
            {allCards.map((card, index) => (
              <div key={index} className="aboutmanet-card">
                <img src={card.logo} alt="icon" className="aboutmanet-logo" />
                <p className="aboutmanet-description">{card.description}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </>
  );
};

export default AboutManet;
